import template from './benefitRequestDays.html';
import controller from './benefitRequestDays.controller';
import './benefitRequestDays.scss';

let benefitRequestDaysComponent = {
  restrict: 'E',
  bindings: {
    request: '<'
  },
  template,
  controller
};

export default benefitRequestDaysComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestDays/benefitRequestDays.component.js